var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPride(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#814DE7",
    d: "M13.291 14A7.968 7.968 0 018 16a7.968 7.968 0 01-5.291-2h10.582z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2D88FF",
    d: "M2.709 14a7.998 7.998 0 01-2.127-3h14.836a7.998 7.998 0 01-2.127 3H2.709z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#45BD62",
    d: "M.582 11A7.96 7.96 0 010 8h16a7.96 7.96 0 01-.582 3H.582z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFCE2E",
    d: "M16 8a7.956 7.956 0 00-.582-3H.582A7.956 7.956 0 000 8h16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF892F",
    d: "M.582 5a7.998 7.998 0 012.127-3h10.582a7.998 7.998 0 012.127 3H.582z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F3425F",
    d: "M2.709 2A7.968 7.968 0 018 0c2.028 0 3.881.755 5.291 2H2.709z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPride);
export default __webpack_public_path__ + "static/media/pride.851b753b8b5f50b18a5e4d04ca0243e1.svg";
export { ForwardRef as ReactComponent };